module.exports = __webpack_public_path__ + "media/images/products/g1c/g1c-1-200x200-c62f95ce3ba8dd0073a972fb66ca7491.png";